module.exports = __webpack_public_path__ + "static/img/gaozhonglishi7.8b936da3.jpg";